// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.notification.ResendSigningEmailsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ResendOnlineSigningEmailsRequestDto } from '../..';

export const ResendSigningEmailsWebApiHandler_resendOnlineSigningEmails_Path =
  '/api/web/v1/notification/resendOnlineSigningEmails';

/**
 * resend signing emails
 */
export const ResendSigningEmailsWebApiHandler_resendOnlineSigningEmails = (
  postData: ResendOnlineSigningEmailsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ResendOnlineSigningEmailsRequestDto, void>(
    {
      endpoint: ResendSigningEmailsWebApiHandler_resendOnlineSigningEmails_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};
